import search from "./search";
import { clearSearch } from "./search";

export function handleHotkey(event) {
    // Set play / pause
    if (
        event.shiftKey && event.code === 'Space'
    ) {
        event.preventDefault();
        document.getElementById('audio-player').paused ? document.getElementById('audio-player').play() : document.getElementById('audio-player').pause()
    }

    // Search
    if (
        event.ctrlKey && event.code === 'KeyF'
    ) {
        event.preventDefault();
        let searchString = window.getSelection().toString();
        document.getElementById('search-box').value = searchString;
        search();
    }

    // Clear search
    if (
        event.code === 'Escape' && document.getElementById('search-box').value != ''
    ) {
        event.preventDefault();
        clearSearch();
    }

    // -5 seconds
    if (
        event.shiftKey && event.code === 'ArrowLeft'
    ) {
        event.preventDefault();
        document.getElementById('audio-player').currentTime -= 5;
    }

    // +5 seconds
    if (
        event.shiftKey && event.code === 'ArrowLeft'
    ) {
        event.preventDefault();
        document.getElementById('audio-player').currentTime += 5;
    }
}
export default handleHotkey;